function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { Callout, useGlobalContext } from 'seagull';
import { useIoContext, useStoreActions } from "../../../../contexts";
import { timeModel } from "../../../../models";
import ManualBillModal from "../../../ManualBillModal/ManualBillModal";
import { BillMode } from "../../../ManualBillModal/ManualBillModal.utils";
import { getCumulativeWarning, getFailureToastText, getSuccessToastText } from "./BillServiceModal.utils";
import CumulativeWarningCallout from "./CumulativeWarningCallout";
import BillServiceModalTable from "./BillServiceModalTable";
import { serviceModel } from "../../../../models";
import { utils } from "../../../../utils";
import { isSameDay } from 'date-fns';
import styles from "./BillServiceModal.module.scss";
import { handleRequest, sendErrReport } from "../../../../infra/utils";
import { getCreditsWarning } from "../../../../business-logic/billingLogic";
const billServiceLoader = 'billService';
/** Allows control over billing of manual services (oneTimeManual/repeatableManual). */
export default function BillServiceModal(props) {
  const {
    serviceWithAmendments: service,
    relationship,
    manualServiceBilling,
    invoiceDateInfo,
    totalCredits,
    dismissModal,
    onRefresh
  } = props;
  const globalContext = useGlobalContext();
  const {
    api,
    logBI
  } = useStoreActions();
  const {
    getNow
  } = useIoContext();
  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      price: '',
      quantity: '',
      note: ''
    }
  });
  async function _onSubmit(data) {
    const {
      mode
    } = data;
    globalContext.startLoader(billServiceLoader);
    const {
      success
    } = await handleRequest(sendBillServiceRequest(data));
    if (!success) {
      globalContext.showErrorToast(getFailureToastText(mode, service.name), "bill-service-".concat(mode, "-error-toast"));
    } else {
      await onRefresh();
      dismissModal();
      globalContext.showSuccessToast(getSuccessToastText(mode, service.name), "bill-service-".concat(mode, "-success-toast"));
    }
    globalContext.stopLoader(billServiceLoader);
  }
  function sendBillServiceRequest(data) {
    const {
      mode,
      issueDate,
      note
    } = data;
    const {
      price,
      quantity
    } = form.getValues();
    const body = {
      quantity: serviceModel.isVariablePrice(service.cost) && quantity ? utils.dollarsToCents(+quantity) : undefined,
      price: serviceModel.isRangePrice(service.cost) ? utils.dollarsToCents(+price) : undefined,
      note: note || undefined
    };
    const billNow = date => api.service.billNow(relationship.id, service.id, _objectSpread(_objectSpread({}, body), {}, {
      requestedBillingDate: date && timeModel.toDatestampObject(date)
    }));
    const billLater = date => api.service.billLater(relationship.id, service.id, _objectSpread(_objectSpread({}, body), {}, {
      requestedBillingDate: timeModel.toDatestampObject(date)
    }));
    switch (mode) {
      case BillMode.Upcoming:
        {
          if (!invoiceDateInfo) {
            const error = new Error('no upcoming invoice to bill');
            sendErrReport(error);
            throw error;
          }
          logBI(10568);
          return billLater(invoiceDateInfo.futureInvoicesDates[0]);
        }
      case BillMode.FutureDate:
        {
          logBI(10582, {
            serviceId: service.id
          });
          return billLater(issueDate);
        }
      case BillMode.Now:
        {
          if (isSameDay(issueDate, getNow())) {
            logBI(10152, {
              serviceId: service.id
            });
            return billNow();
          } else {
            logBI(10578, {
              serviceId: service.id
            });
            return billNow(issueDate);
          }
        }
    }
  }
  return /*#__PURE__*/React.createElement(ManualBillModal, {
    title: "Bill Service",
    invoiceDateInfo: invoiceDateInfo,
    manualServiceBilling: manualServiceBilling,
    effectiveDate: relationship.effectiveDate,
    form: form,
    onCancel: dismissModal,
    onSubmit: data => form.handleSubmit(() => _onSubmit(data))(),
    infoBoxContent: _ref => {
      let {
        mode,
        issueDate
      } = _ref;
      const cumulativeWarning = getCumulativeWarning(service, issueDate, manualServiceBilling);
      const creditsWarning = getCreditsWarning(mode, totalCredits);
      return /*#__PURE__*/React.createElement("div", {
        className: styles.callouts
      }, cumulativeWarning && /*#__PURE__*/React.createElement(CumulativeWarningCallout, _extends({}, cumulativeWarning, {
        service: service
      })), (serviceModel.isAwaitingApproval(service.status) || serviceModel.isAmended(service.status)) && /*#__PURE__*/React.createElement(Callout, {
        "data-testid": "pending-amendment-callout",
        intent: "warning"
      }, "As this service is part of a pending amendment, the invoice will require client approval."), creditsWarning && /*#__PURE__*/React.createElement(Callout, {
        "data-testid": "has-credits-callout"
      }, creditsWarning.text));
    },
    tableContent: _ref2 => {
      let {
        issueDate
      } = _ref2;
      return /*#__PURE__*/React.createElement(FormProvider, form, /*#__PURE__*/React.createElement(BillServiceModalTable, {
        service: service,
        billingContext: {
          issueDate,
          manualServiceBilling
        }
      }));
    }
  });
}